import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Menu, X, Phone, ChevronDown } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
interface NavChild {
  title: string;
  url: string;
}
interface NavItem {
  title: string;
  url: string;
  children?: NavChild[];
}
export function ProgramsNavigation() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState<string | null>(null);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsOpen(false);
    setOpenSubmenu(null);
  }, [location]);
  const navLinks: NavItem[] = [{
    title: 'Programs',
    url: '/programs'
  }, {
    title: 'Classes',
    url: '/classes',
    children: [{
      title: 'Taekwondo',
      url: '/classes/taekwondo'
    }, {
      title: 'Kickboxing',
      url: '/classes/kickboxing'
    }, {
      title: 'Homeschool',
      url: '/classes/homeschool'
    }, {
      title: 'Group & Corporate Self Defense Seminars',
      url: '/classes/self-defense-seminars'
    }, {
      title: 'Private Classes',
      url: '/classes/private-classes'
    }, {
      title: 'Our Classes Schedule',
      url: '/schedule'
    }, {
      title: 'Our Facility',
      url: '/facility'
    }]
  }, {
    title: 'Benefits',
    url: '/benefits-for-children',
    children: [{
      title: 'Child Benefits',
      url: '/benefits-for-children'
    }, {
      title: 'Teen Benefits',
      url: '/benefits-for-teens'
    }, {
      title: 'Adult Benefits',
      url: '/benefits-for-adults'
    }, {
      title: 'Family Benefits',
      url: '/benefits-for-families'
    }, {
      title: 'Personal Safety',
      url: '/selfdefensetips'
    }]
  }, {
    title: 'Midwest Cup 2026',
    url: '/midwest-cup-2026',
    children: [{
      title: 'Event Details',
      url: '/midwest-cup-2026'
    }, {
      title: 'Tournament Registration',
      url: '/midwest-cup-2026#registration'
    }]
  }, {
    title: 'About',
    url: '/about'
  }, {
    title: 'Forms',
    url: '/forms'
  }, {
    title: 'Contact',
    url: '/contact'
  }];
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-black shadow-lg py-2 transition-all duration-300" data-id="element-1697">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1698">
        <div className="flex justify-between items-center" data-id="element-1699">
          <Link to="/" className="flex items-center gap-3 group" data-id="element-1700">
            <div className="relative w-16 h-16 overflow-hidden rounded-full border-2 border-[#00D4FF] bg-black" data-id="element-1701">
              <img src="https://cdn.magicpatterns.com/uploads/fmBXjQm2BPtC5bTSRKvwCz/walkerlogo-gigapixel-cgi-3600w.png" alt="Walker's Martial Arts Logo" className="w-full h-full object-cover" data-id="element-1702" />
            </div>
            <div className="flex flex-col" data-id="element-1703">
              <span className="text-white font-bold text-xl leading-none tracking-wide uppercase" data-id="element-1704">
                Walker's
              </span>
              <span className="text-[#00D4FF] font-bold text-base leading-none tracking-wider uppercase" data-id="element-1705">
                Martial Arts
              </span>
            </div>
          </Link>

          <div className="hidden md:flex items-center gap-8" data-id="element-1706">
            {navLinks.map(link => <div key={link.title} className="relative group" data-id="element-1707">
                {link.children ? <>
                    {link.url ? <Link to={link.url} className={`transition-colors font-medium text-sm uppercase tracking-wider flex items-center gap-1 ${link.children.some(child => child.url === location.pathname) ? 'text-[#00D4FF]' : 'text-gray-300 hover:text-[#00D4FF]'}`} data-id="element-1708">
                        {link.title}
                        <ChevronDown className="w-4 h-4" data-id="element-1709" />
                      </Link> : <span className={`transition-colors font-medium text-sm uppercase tracking-wider flex items-center gap-1 cursor-default ${link.children.some(child => child.url === location.pathname) ? 'text-[#00D4FF]' : 'text-gray-300 hover:text-[#00D4FF]'}`} data-id="element-1710">
                        {link.title}
                        <ChevronDown className="w-4 h-4" data-id="element-1711" />
                      </span>}
                    <div className="absolute top-full left-0 mt-2 w-48 bg-black/95 backdrop-blur-sm border border-gray-800 rounded-lg shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200" data-id="element-1712">
                      {link.children.map(child => child.url ? <Link key={child.url} to={child.url} className={`block px-4 py-3 text-sm font-medium transition-colors ${location.pathname === child.url ? 'text-[#00D4FF] bg-[#00D4FF]/10' : 'text-gray-300 hover:text-[#00D4FF] hover:bg-[#00D4FF]/5'}`} data-id="element-1713">
                            {child.title}
                          </Link> : <span key={child.title} className="block px-4 py-3 text-sm font-medium text-gray-500 cursor-default" data-id="element-1714">
                            {child.title}
                          </span>)}
                    </div>
                  </> : link.url ? <Link to={link.url} className={`transition-colors font-medium text-sm uppercase tracking-wider ${location.pathname === link.url ? 'text-[#00D4FF]' : 'text-gray-300 hover:text-[#00D4FF]'}`} data-id="element-1715">
                    {link.title}
                  </Link> : <span className="font-medium text-sm uppercase tracking-wider text-gray-500 cursor-default" data-id="element-1716">
                    {link.title}
                  </span>}
              </div>)}
            <Link to="/free-trial" className="bg-[#00D4FF] text-black px-6 py-2.5 rounded font-bold uppercase tracking-wider text-sm hover:bg-[#33ddff] transition-colors shadow-[0_0_15px_rgba(0,212,255,0.3)] hover:shadow-[0_0_25px_rgba(0,212,255,0.5)]" data-id="element-1717">
              Free Trial
            </Link>
          </div>

          <button onClick={() => setIsOpen(true)} className="md:hidden text-white p-2 hover:text-[#00D4FF] transition-colors" aria-label="Open menu" data-id="element-1718">
            <Menu size={28} data-id="element-1719" />
          </button>
        </div>
      </div>

      <AnimatePresence data-id="element-1720">
        {isOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setIsOpen(false)} className="fixed inset-0 bg-black/80 backdrop-blur-sm z-40 md:hidden" data-id="element-1721" />
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 200
        }} className="fixed top-0 right-0 bottom-0 w-[280px] bg-[#1a1a1a] z-50 shadow-2xl border-l border-gray-800 flex flex-col" data-id="element-1722">
              <div className="p-6 flex justify-between items-center border-b border-gray-800" data-id="element-1723">
                <span className="text-white font-bold text-lg" data-id="element-1724">Menu</span>
                <button onClick={() => setIsOpen(false)} className="text-gray-400 hover:text-white transition-colors" data-id="element-1725">
                  <X size={24} data-id="element-1726" />
                </button>
              </div>
              <div className="flex-1 overflow-y-auto py-6 px-6 flex flex-col gap-4" data-id="element-1727">
                <Link to="/" onClick={() => setIsOpen(false)} className="text-lg font-medium text-gray-300 hover:text-[#00D4FF] transition-colors" data-id="element-1728">
                  Home
                </Link>
                {navLinks.map(link => <div key={link.title} data-id="element-1729">
                    {link.children ? <>
                        <a href="#" onClick={e => {
                  e.preventDefault();
                  setOpenSubmenu(openSubmenu === link.title ? null : link.title);
                }} className={`w-full text-left text-lg font-medium transition-colors flex items-center justify-between ${link.children.some(child => child.url === location.pathname) ? 'text-[#00D4FF]' : 'text-gray-300 hover:text-[#00D4FF]'}`} data-id="element-1730">
                          {link.title}
                          <ChevronDown className={`w-4 h-4 transition-transform ${openSubmenu === link.title ? 'rotate-180' : ''}`} data-id="element-1731" />
                        </a>
                        <AnimatePresence data-id="element-1732">
                          {openSubmenu === link.title && <motion.div initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.2
                  }} className="overflow-hidden" data-id="element-1733">
                              <div className="pl-4 pt-2 space-y-2" data-id="element-1734">
                                {link.children.map(child => child.url ? <Link key={child.url} to={child.url} onClick={() => setIsOpen(false)} className={`block py-2 text-sm font-medium transition-colors ${location.pathname === child.url ? 'text-[#00D4FF]' : 'text-gray-400 hover:text-[#00D4FF]'}`} data-id="element-1735">
                                      {child.title}
                                    </Link> : <span key={child.title} className="block py-2 text-sm font-medium text-gray-500 cursor-default" data-id="element-1736">
                                      {child.title}
                                    </span>)}
                              </div>
                            </motion.div>}
                        </AnimatePresence>
                      </> : link.url ? <Link to={link.url} onClick={() => setIsOpen(false)} className={`text-lg font-medium transition-colors block ${location.pathname === link.url ? 'text-[#00D4FF]' : 'text-gray-300 hover:text-[#00D4FF]'}`} data-id="element-1737">
                        {link.title}
                      </Link> : <span className="text-lg font-medium text-gray-500 cursor-default block" data-id="element-1738">
                        {link.title}
                      </span>}
                  </div>)}
                <hr className="border-gray-800 my-2" data-id="element-1739" />
                <Link to="/free-trial" onClick={() => setIsOpen(false)} className="bg-[#00D4FF] text-black py-3 rounded text-center font-bold uppercase tracking-wider hover:bg-[#33ddff] transition-colors block" data-id="element-1740">
                  Schedule Free Trial
                </Link>
                <div className="mt-auto pt-8" data-id="element-1741">
                  <div className="flex items-center gap-3 text-gray-400 mb-2" data-id="element-1742">
                    <Phone size={18} className="text-[#00D4FF]" data-id="element-1743" />
                    <span className="text-sm" data-id="element-1744">Call us today</span>
                  </div>
                  <p className="text-white font-medium text-lg" data-id="element-1745">
                    Bloomington, IL
                  </p>
                </div>
              </div>
            </motion.div>
          </>}
      </AnimatePresence>
    </nav>;
}